import { render, staticRenderFns } from "./BuildBank.vue?vue&type=template&id=4033fcc9&"
import script from "./BuildBank.vue?vue&type=script&lang=js&"
export * from "./BuildBank.vue?vue&type=script&lang=js&"
import style0 from "./BuildBank.vue?vue&type=style&index=0&id=4033fcc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports